module.exports = __webpack_public_path__ + "img/Bananengeist.c7760c74.svg";